import styled from 'styled-components';
const menuHeight = '60px';
const menuBtnSize = '50px';
const menuBtnSizeReduced = '45px';
const menuBtnsSize = '40px';
const menuBtnsSizeReduced = '35px';
const topMarginHeight = '40px';
const topMarginWithoutNavbar = '0px';

export const VTTContainer = styled.div`
  background: transparent;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  position: absolute;
  z-index: 1;
  align-items: center;
  top: ${({ displayNav }) => (displayNav ? topMarginHeight : topMarginWithoutNavbar)};
  right: 0;
  padding: 10px;

  @media screen and (max-width: 768px) {
    margin-top: ${({ displayNav }) => (displayNav ? topMarginHeight : topMarginWithoutNavbar)};
  }
`;

export const VTTWrapper = styled.div``;

export const VTTRow = styled.div`
  height: ${menuHeight};
  display: ${({ mesura }) => (mesura ? 'grid' : 'flex')};
  flex-direction: column;
  flex-flow: column-reverse;
  grid-template-columns: 2fr 1fr;
  padding: 0px;
`;

export const VTTMenuIconWrapper = styled.div`
  display: flex;
  text-align: center;
  margin: auto;
  height: 60px;
  width: 100%;
  padding: 2px;
`;

export const VTTMenuIconBtn = styled.div`
  display: flex;
  border-radius: 50%;
  height: ${menuBtnSizeReduced};
  justify-content: center;
  align-items: center;
  border: 0;
  margin: auto;
  cursor: ${({ editing }) => (editing ? 'default' : 'pointer')};
  width: ${menuBtnSizeReduced};
  z-index: 2;
  background-color: ${({ selected }) => (selected ? '#febf00' : '#666666')};

  @media screen and (max-width: 768px) {
    height: ${menuBtnSize};
    width: ${menuBtnSize};
  }
`;

export const VTTMenuIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  width: 28px;
  height: 28px;
  margin: auto;
  display: flex;
  filter: invert(1);
`;

export const VTTRowBtns = styled.div`
  height: ${menuHeight};
  grid-template-columns: 1fr 1fr;
  padding: 0px;
  display: grid;
`;

export const VTTSecondaryMenuButtonFirst = styled.div`
  text-align: center;
  margin: auto;
  /* height: ${menuHeight}; */
  width: 100%;
  padding: 2px;
  margin: auto;
  display: flex;

  opacity: ${({ open, active }) => (open && active ? '100%' : '0%')};
  position: relative;

  animation: ${({ open, active }) => (active ? (!open ? `openMenu 0.4s ease-in-out forwards` : `closeMenu 0.2s 0.2s ease-out forwards`) : null)};

  @keyframes openMenu {
    0% {
      transform: translateX(0%);
      opacity: 0%;
    }
    50% {
      transform: translateX(0%);
      opacity: 0%;
    }
    100% {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes closeMenu {
    0% {
      transform: translateX(0%);
      opacity: 100%;
    }
    100% {
      transform: translateX(200%);
      opacity: 0%;
    }
  }
`;

export const VTTSecondaryMenuButtonSecond = styled.div`
  text-align: center;
  margin: auto;
  /* height: ${menuHeight}; */
  width: 100%;
  padding: 2px;
  margin: auto;
  display: flex;
  opacity: ${({ open, active }) => (open && active ? '100%' : '0%')};
  position: relative;

  animation: ${({ open, active }) => (active ? (!open ? `openMenu 0.2s ease-out forwards` : `closeMenu 0.4s 0.2s ease-out forwards`) : null)};

  @keyframes openMenu {
    0% {
      transform: translateX(200%);
      opacity: 0%;
    }
    100% {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes closeMenu {
    0% {
      transform: translateX(0%);
      opacity: 100%;
    }
    50% {
      transform: translateX(0%);
      opacity: 100%;
    }
    100% {
      transform: translateX(100%);
      opacity: 0%;
    }
  }
`;

export const VTTSecondaryRowButtons = styled.div`
  position: absolute;
  width: ${menuBtnSizeReduced};
  top: 100%;
  display: flex;
  visibility: ${({ showIcons }) => (showIcons ? 'visible' : 'hidden')};
  opacity: 0%;
  flex-direction: column;
  gap: 8px;

  animation: ${({ open }) => (!open ? `openMenuColumn 0.2s 0.4s ease-out forwards` : `closeMenuColumn 0.2s ease-out forwards`)};

  @keyframes openMenuColumn {
    0% {
      transform: translateY(-48px);
      opacity: 0%;
      visibility: visible;
    }
    100% {
      transform: translateY(0px);
      opacity: 100%;
    }
  }

  @keyframes closeMenuColumn {
    0% {
      transform: translateY(0px);
      opacity: 100%;
    }
    100% {
      transform: translateY(-48px);
      opacity: 0%;
      visibility: hidden;
    }
  }
`;

export const VTTSecondaryMenuIconButton = styled.div`
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background-color: ${({ drawing }) => (drawing ? '#febf00' : '#666666')};
  height: ${menuBtnSizeReduced};
  width: ${menuBtnSizeReduced};
  border: 0;
  margin: auto;
  z-index: 1;

  @media screen and (max-width: 768px) {
    height: ${menuBtnSizeReduced};
    width: ${menuBtnSizeReduced};
  }
`;

export const VTTIconWrapperRulerPencil = styled.div`
  text-align: center;
  margin: auto;
  height: ${menuHeight};
  width: 100%;
  padding: 2px;
  margin: auto;
  display: ${({ active }) => (!active ? 'none' : 'flex')};
  animation: ${({ open, active }) => (active ? (!open ? 'openModalRP 0.2s ease-out forwards' : 'closeModalRP 0.6s ease-out forwards') : null)};

  @keyframes openModalRP {
    0% {
      transform: translateX(100%);
      opacity: 0%;
    }
    100% {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes closeModalRP {
    0% {
      transform: translateX(0%);
      opacity: 100%;
    }
    66% {
      transform: translateX(0%);
      opacity: 100%;
    }
    100% {
      transform: translateX(100%);
      opacity: 0%;
    }
  }
`;

export const VTTIconWrapperPencil = styled.div`
  text-align: center;
  margin: auto;
  height: ${menuHeight};
  width: 100%;
  padding: 2px;
  margin: auto;
  display: ${({ active }) => (!active ? 'none' : 'flex')};
  animation: ${({ open, active }) => (active ? (!open ? 'openModalP 0.4s ease-out forwards' : 'closeModalP 0.4s ease-out forwards') : null)};

  @keyframes openModalP {
    0% {
      transform: translateX(200%);
      opacity: 0%;
    }
    50% {
      transform: translateX(200%);
      opacity: 0%;
    }
    100% {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes closeModalP {
    0% {
      transform: translateX(0%);
      opacity: 100%;
    }
    50% {
      transform: translateX(0%);
      opacity: 100%;
    }
    100% {
      transform: translateX(200%);
      opacity: 0%;
    }
  }
`;

export const VTTIconWrapperRuler = styled.div`
  text-align: center;
  margin: auto;
  height: ${menuHeight};
  width: 100%;
  padding: 2px;
  margin: auto;
  display: ${({ active }) => (!active ? 'none' : 'flex')};
  animation: ${({ open, active }) => (active ? (!open ? 'openModalR 0.6s ease-out forwards' : 'closeModalR 0.2s ease-out forwards') : null)};

  @keyframes openModalR {
    0% {
      transform: translateX(300%);
      opacity: 0%;
    }
    66% {
      transform: translateX(300%);
      opacity: 0%;
    }
    100% {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes closeModalR {
    0% {
      transform: translateX(0%);
      opacity: 100%;
    }
    100% {
      transform: translateX(300%);
      opacity: 0%;
    }
  }
`;

export const VTTIconBtn = styled.div`
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'default')};
  background-color: ${({ selected, enabled }) => (enabled ? (selected ? '#febf00' : '#666666') : '#666666')};
  height: ${menuBtnsSize};
  width: ${menuBtnsSize};
  border: 0;
  margin: auto;
  z-index: 1;

  @media screen and (max-width: 768px) {
    height: ${menuBtnsSize};
    width: ${menuBtnsSize};
  }
`;

export const VTTIconBtnDelete = styled.button`
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected, enabled }) => (enabled ? (selected ? '#febf00' : '#666666') : '#666666')};
  height: ${menuBtnsSize};
  width: ${menuBtnsSize};
  border: 0;
  margin: auto;
  z-index: 1;

  @media screen and (max-width: 768px) {
    height: ${menuBtnsSize};
    width: ${menuBtnsSize};
  }
`;

export const VTTIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  filter: ${({ selected }) => (selected ? 'none' : 'brightness(0) invert(1)')};

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;
export const VTTIconDelete = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  filter: ${({ selected }) => (selected ? 'none' : 'brightness(0) invert(1)')};
  transform: rotate(180deg);

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;
